<div class="menu-dropdown" [class]="hostClass()">
  <div class="menu-dropdown-header w-100" tabindex="0" (click)="open()" (keydown.enter)="open()">
    <span class="d-flex align-items-center  w-100" [ngClass]="dropdownMenu().icon ? 'gap-8': ''">
       <i class="fs-24" [class]="dropdownMenu().icon"></i>
        <span class="d-flex flex-column  w-100">
         <span [ngClass]="dropdownMenu().subText ? 'fw-600': ''" class="item-text">{{ dropdownMenu().text | translate | capitalize }}</span>
          @if(dropdownMenu().subText) {
            <span class="pt-8 item-text">{{ dropdownMenu().subText! | translate | capitalize }}</span>
          }
        </span>
    </span>
    <span [ngClass]="(dropdownMenu().icon ? 'ms-auto' : '') + (dropdownMenu().subText ? ' pe-16' : '')"><i class="rc-icon-chevron-down"></i></span>
  </div>
  @if (this.opened()) {
    @for (item of dropdownMenu().items; track item) {
      @let link = (prefix() && !item.url?.startsWith('/')) ? `${prefix()}/${item.url}` : item.url;
<!--      @let link = prefix() ? `${prefix()}/${item.url}` : item.url;-->
      <a
        class="menu-item sub-item"
        [ngClass]="itemClass()"
        [routerLink]="[`${link}`]"
        [rcNavigate]="link"
        [queryParams]="item.params"
        [routerLinkActive]="['active']"
        (click)="linkClicked.emit()"
        [routerLinkActiveOptions]="{
          paths: 'subset',
          fragment: 'ignored',
          matrixParams: 'ignored',
          queryParams: 'ignored',
        }">
        <span>{{ item.text | translate | capitalize }}</span>
      </a>
    }
  }
</div>
